<template>
  <div class="workspace">
    <tabs-bar></tabs-bar>

    <div class="conteudo">
      <div class="painel" v-show="abaAtiva === 'inicio'">
        <welcome-view></welcome-view>
      </div>

      <div
        class="painel"
        v-for="aba in tabs"
        :key="aba.lk_link + ':' + reloadToken(aba.lk_link)"
        v-show="abaAtiva === aba.lk_link"
      >
        <report-viewer :aba="aba"></report-viewer>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import WelcomeView from './WelcomeView.vue'
import TabsBar from './TabsBar.vue'
import ReportViewer from './ReportViewer.vue'
import { flattenMenus } from '@/utils/relatorios'

export default {
  name: 'HelloWorld',
  components: {
    WelcomeView,
    TabsBar,
    ReportViewer
  },
  computed: {
    tabs() {
      return this.$store.getters['abas/tabs']
    },
    abaAtiva() {
      return this.$store.getters['abas/abaAtiva']
    }
  },
  methods: {
    reloadToken(lkLink) {
      return this.$store.getters['abas/reloadToken'](lkLink)
    }
  },
  created() {
    // Suporte a deep-link: /bi/:link abre a aba correspondente após os menus carregarem.
    const linkInicial = this.$route.params.link

    if (linkInicial && linkInicial !== 'inicio') {
      this.$store.dispatch('busca/getMenus').then(() => {
        const todos = flattenMenus(this.$store.getters['busca/getMenus'])
        const encontrado = todos.find(l => l.lk_link === linkInicial)

        if (encontrado) {
          this.$store.dispatch('abas/abrirRelatorio', encontrado)
        }
      })
    }
  }
}
</script>

<style scoped>
.workspace {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--rd-bg-app);
}

.conteudo {
  flex: 1;
  position: relative;
  min-height: 0;
  background: var(--rd-bg-2);
  border-top-left-radius: 12px;
  overflow: hidden;
}

.painel {
  position: absolute;
  inset: 0;
  overflow: auto;
}
</style>
